module.exports = __webpack_public_path__ + "static/plan3d-b33afd3dce79560452cd0f5d6df67420.png";